import { COLORS, FONT_HEADING, BUTTON_HOVER } from '../../talkTreeShared/Tree/constants/theme';

const TALK_TREE_GUIDE_URL = 'https://www.talktrees.ai/playbooks/how-to-introduce-talk-trees';

// Each step: title, description (string or JSX), optional tip, optional link { label, href }.
const steps = [
  {
    title: 'Make a recording',
    description: 'Record a class discussion using a device you already have such as your phone or tablet. Aim for clear audio and a typical discussion day.',
    tip: 'Place your device in a central location, such as a desk in the middle of the room, so it can capture student voices as clearly as possible.',
  },
  {
    title: 'Upload your recording',
    description: 'Use the Upload Recording form to submit your file, title, and optional description to begin processing, (Upload speed depends on your connection.)',
    tip: 'You can use recordings created with built-in apps such as Voice Memos (iPhone or Mac), Voice Recorder/Sound Recorder (Android or Windows), or similar recording applications.',
  },
  {
    title: 'We analyze and generate your Talk Tree',
    description: (
      <>
        The Talk Trees application will process your recording and create a Talk Tree view of the conversation. <strong>This typically takes about 30 minutes.</strong>
      </>
    ),
  },
  {
    title: 'Use your Talk Tree to reflect and celebrate',
    description: 'Once you see the Talk Tree Ready status, click it to explore your Talk Tree. Use the tree with your class to celebrate and reflect on student talk. Use multiple Talk Trees to compare how talk changes in your class over time.',
    link: { label: 'How to use your Talk Tree →', href: TALK_TREE_GUIDE_URL },
  },
];

export default function UploadHelpDialog({ onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      backgroundColor: 'rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000,
    }}>
      <div style={{
        width: '92%', maxWidth: 800, maxHeight: '95vh',
        backgroundColor: '#FDFBFA', padding: '24px 1.25rem',
        boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
        display: 'flex', flexDirection: 'column', gap: '24px',
        overflowY: 'auto', position: 'relative', textAlign: 'left',
        borderRadius: '12px',
      }}>
        <div onClick={onClose} style={{ position: 'absolute', top: 24, right: 28, cursor: 'pointer', fontSize: '24px', color: COLORS.textMuted, lineHeight: 1, fontWeight: 300 }}>✕</div>
        <h2 style={{ fontFamily: FONT_HEADING, fontSize: '24px', fontWeight: 500, color: COLORS.primary, margin: 0 }}>How to upload a recording</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
          {steps.map((step, i) => (
            <div key={i} style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
              <div style={{ width: 40, height: 40, minWidth: 40, borderRadius: '50%', backgroundColor: '#BFDBFE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: 700, color: '#ffffff' }}>{i + 1}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <span style={{ fontSize: '15px', fontWeight: 700, color: '#111827' }}>{step.title}</span>
                <span style={{ fontSize: '14px', color: COLORS.text, lineHeight: 1.6 }}>
                  {step.description}
                </span>
                {step.tip && (
                  <span style={{ fontSize: '14px', color: COLORS.text, lineHeight: 1.6 }}>
                    <strong style={{ color: '#111827' }}>Tip:</strong> {step.tip}
                  </span>
                )}
                {step.link && (
                  <a
                    href={step.link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: '14px', lineHeight: 1.6, color: COLORS.primary, textDecoration: 'underline', width: 'fit-content' }}
                  >
                    {step.link.label}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: '8px', }}>
          <button
            onClick={onClose}
            style={{ backgroundColor: COLORS.primaryDark, color: COLORS.white, border: 'none', borderRadius: '4px', padding: '10px 1.25rem', fontSize: '15px', fontWeight: 600, cursor: 'pointer', transition: 'background 0.15s ease', width: 'auto', textAlign: 'left' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = BUTTON_HOVER.gradient; e.currentTarget.style.boxShadow = BUTTON_HOVER.shadow; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = COLORS.primaryDark; e.currentTarget.style.boxShadow = 'none'; }}
          >
            I'm ready to upload my recording
          </button>
        </div>
      </div>
    </div>
  );
}